"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeAd = void 0;
const zod_1 = require("zod");
const asset_definition_1 = require("./asset-definition");
exports.NativeAd = zod_1.z.object({
    assets: asset_definition_1.AssetDefinition.array(),
    link: zod_1.z.object({
        url: zod_1.z.string().url(),
        clicktrackers: zod_1.z.string().url().array().optional(),
    }),
    ver: zod_1.z.string().optional(),
    eventtrackers: zod_1.z
        .object({
        event: zod_1.z.number(),
        method: zod_1.z.number(),
        url: zod_1.z.string().url().optional(),
    })
        .array()
        .optional(),
    privacy: zod_1.z.string().url().optional(),
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF0aXZlLWFkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL25hdGl2ZS1hZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBdUI7QUFFdkIseURBQW9EO0FBRXZDLFFBQUEsUUFBUSxHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQUM7SUFDL0IsTUFBTSxFQUFFLGtDQUFlLENBQUMsS0FBSyxFQUFFO0lBQy9CLElBQUksRUFBRSxPQUFDLENBQUMsTUFBTSxDQUFDO1FBQ2IsR0FBRyxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLEVBQUU7UUFDckIsYUFBYSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxRQUFRLEVBQUU7S0FDbkQsQ0FBQztJQUNGLEdBQUcsRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsUUFBUSxFQUFFO0lBQzFCLGFBQWEsRUFBRSxPQUFDO1NBQ2IsTUFBTSxDQUFDO1FBQ04sS0FBSyxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUU7UUFDakIsTUFBTSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUU7UUFDbEIsR0FBRyxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxRQUFRLEVBQUU7S0FDakMsQ0FBQztTQUNELEtBQUssRUFBRTtTQUNQLFFBQVEsRUFBRTtJQUNiLE9BQU8sRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsR0FBRyxFQUFFLENBQUMsUUFBUSxFQUFFO0NBQ3JDLENBQUMsQ0FBQSJ9